// ── Municipality positions — SVG viewBox 0 0 1100 1050
// v4: global +35 Y correction applied on top of v3 per-canton adjustments
// All pins shifted 35 SVG units downward (~21px at 87% zoom)

export const MUNIS = {
  "Una-Sana": [
    ["Bihać",              42.3,  183.1, 0, 0],
    ["Cazin",             31,  74.1, 0, 0],
    ["Velika Kladuša",     48.4,  42.3, 0, 0],
    ["Bužim",             78.7,  57.6, 0, 0],
    ["Bosanska Krupa",    116.7,  153.2, 0, 0],
    ["Bosanski Petrovac", 169.2,  266.9, 0, 0],
    ["Ključ",             286.2,  273.5, 0, 0],
    ["Sanski Most",       237.7,  197.7, 0, 0],
  ],
  "Posavina": [
    ["Orašje",            808,  78.6, 0, 0],
    ["Domaljevac-Šamac",  708.3,  81.1, 0, 0],
    ["Odžak",             707.4,  63.8, 0, 0],
  ],
  "Tuzla": [
    ["Tuzla",       828.4, 259.2, 0, 0],
    ["Lukavac",     747.3, 258.6, 0, 0],
    ["Živinice",    835.9, 300.2, 0, 0],
    ["Kalesija",    887.3, 282.9, 0, 0],
    ["Sapna",       899.3, 259.8, 0, 0],
    ["Teočak",      904.2, 240.8, 0, 0],
    ["Čelić",       825.8, 199.6, 0, 0],
    ["Srebrenik",   762.2, 204.8, 0, 0],
    ["Gradačac",    743.4, 144.4, 0, 0],
    ["Gračanica",   716.2, 180.2, 0, 0],
    ["Doboj-Istok", 677.4, 195.2, 0, 0],
    ["Banovići",    765, 322.3, 0, 0],
    ["Kladanj",     818.3, 384.7, 0, 0],
  ],
  "Zenica-Doboj": [
    ["Zenica",      604.9, 392.8, 0, 0],
    ["Visoko",      678.8, 482.1, 0, 0],
    ["Kakanj",      650.3, 434.8, 0, 0],
    ["Breza",       719.9, 473.8, 0, 0],
    ["Vareš",       740.1, 432.7, 0, 0],
    ["Olovo",       793.7, 423, 0, 0],
    ["Zavidovići",  698.1, 350.2, 0, 0],
    ["Žepče",       622.3, 320.5, 0, 0],
    ["Maglaj",      680.4, 276.9, 0, 0],
    ["Tešanj",      618.7, 258.2, 0, 0],
    ["Doboj-Jug",   642.3, 239.4, 0, 0],
    ["Usora",       621.7, 219.5, 0, 0],
  ],
  "Bosnian-Podrinje": [
    ["Goražde",          889.6, 606.9, 0, 0],
    ["Foča",  845.4, 618.7, 0, 0],
    ["Pale",       874.5, 577.7, 0, 0],
  ],
  "Central Bosnia": [
    ["Travnik",                525.8, 372.9, 0, 0],
    ["Novi Travnik",           525.8, 426, 0, 0],
    ["Vitez",                  568.3, 419.6, 0, 0],
    ["Busovača",               608, 458.6, 0, 0],
    ["Kiseljak",               656.4, 504.3, 0, 0],
    ["Fojnica",                598.7, 504.7, 0, 0],
    ["Kreševo",                638.9, 540.8, 0, 0],
    ["Jajce",                  424.3, 346.7, 0, 0],
    ["Dobretići",              459.9, 329.8, 0, 0],
    ["Donji Vakuf",            445.3, 419, 0, 0],
    ["Bugojno",                461.7, 469.1, 0, 0],
    ["Gornji Vakuf-Uskoplje",  495.5, 509.4, 0, 0],
  ],
  "Herzegovina-Neretva": [
    ["Mostar",      580.9, 705.8, 0, 0],
    ["Konjic",      670.2, 639.3, 0, 0],
    ["Jablanica",   533.3, 610, 0, 0],
    ["Prozor", 500, 565.6, 0, 0],
    ["Čapljina",    568.3, 855.5, 0, 0],
    ["Stolac",      636.5, 844.4, 0, 0],
    ["Neum",        557.8, 902.6, 0, 0],
    ["Ravno",       654.9, 937.6, 0, 0],
    ["Čitluk",      538.1, 771, 0, 0],
  ],
  "West Herzegovina": [
    ["Široki Brijeg", 529.8, 721.2, 0, 0],
    ["Ljubuški",      502.6, 787, 0, 0],
    ["Grude",         462.6, 735.5, 0, 0],
    ["Posušje",       458.3, 666.9, 0, 0],
  ],
  "Sarajevo": [
    ["Stari Grad Sarajevo",    769.1, 510.4, 0, 0],
    ["Centar Sarajevo",        750.6, 521.9, 0, 0],
    ["Novo Sarajevo", 749.6, 537.2, 0, 0],
    ["Novi Grad Sarajevo",     719.7, 530.3, 0, 0],
    ["Ilidža",        718.7, 550.6, 0, 0],
    ["Hadžići",       681.5, 566.5, 0, 0],
    ["Trnovo",        745, 607.2, 0, 0],
    ["Ilijaš",        770.8, 472.4, 0, 0],
    ["Vogošća",       747, 502.3, 0, 0],
  ],
  "Canton 10": [
    ["Livno",              293.6, 534.4, 0, 0],
    ["Tomislavgrad",       400.2, 627, 0, 0],
    ["Kupres",             430.3, 514.7, 0, 0],
    ["Glamoč",             289, 425.5, 0, 0],
    ["Bosansko Grahovo",   185.3, 431, 0, 0],
    ["Drvar",              190.6, 349.3, 0, 0],
  ],
};